module.exports = __webpack_public_path__ + "img/tutorial_books_05.29758579.gif";